import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import { fDate } from "../../../../../utils2/formatTime";
import NoSessionsAvailable from "./components/NoSessionsAvailable";
import DisableBlueSmallButton from "../../../../components/customButtons/DisableSmallBlueButton";

export default function ViewUpcomingDemoAndClasses({
  demoAndClassData,
  upcomingSessionsLoading,
  selectedDate,
}) {
  const navigate = useNavigate();
  const paginationRef = useRef(null);
  const swiperRef = useRef(null); // ✅ Define swiperRef
  const [paginationHight, setPaginationHight] = React.useState(null);

  useEffect(() => {
    const handleResize = () => swiperRef.current?.swiper?.update();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigateToZoomLink = (link) => {
    const zoomLink = link;



    window.open(zoomLink, "_blank");
  };

  const isToday = (date) => {
  const today = new Date();
  const selected = new Date(date);

  today.setHours(0, 0, 0, 0);
  selected.setHours(0, 0, 0, 0);

  return today.getTime() === selected.getTime();
};


  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            fontSize="20px"
            color="#000000"
            sx={{ fontWeight: 600, fontFamily: "Inter" }}
          >
            Session for {fDate(selectedDate)}
          </Typography>
        </Grid>

        {upcomingSessionsLoading ? (
          <Grid item xs={12}>
            <Loader text="Loading Sessions" height="20vh" />
          </Grid>
        ) : !upcomingSessionsLoading && demoAndClassData?.length > 0 ? (
          <Box
            mt={1}
            mb={1}
            sx={{
              width: "100%",
              maxWidth: {
                xs: 375,
                sm: 500,
                md: 700,
                lg: 900,
                xl: 1200,
              },
              // minHeight: { xs: "100px", md: "100px" },
              border: "none",
              boxShadow: "none",
              position: "relative",
            }}
          >
            <Box width="100%" sx={{ border: "none", boxShadow: "none" }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={20}
                slidesPerView={1}
                pagination={{ clickable: true }} // No el here
                onBeforeInit={(swiper) => {
                  swiper.params.pagination.el = paginationRef.current;
                }}
                autoplay={{
                  delay: 3000,
                  // disableOnInteraction: false,
                }}
                loop
                style={{
                  padding: "0 5px 7px", // ← Add horizontal padding
                  // ← Allow shadows/rounded corners to be visible
                }}
                observer={true}
                observeParents={true}
                resizeObserver={true}
                breakpoints={{
                  // small screens (mobile)
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  // tablets
                  600: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                  },
                  // small desktops
                  900: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  // large desktops
                  1200: {
                    slidesPerView: 1,
                    spaceBetween: 25,
                  },
                }}
              >
                {demoAndClassData?.map((data, index) => (
                  <SwiperSlide key={index}>
                    <Grid item xs={12} mt={2}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: "22px",
                          boxShadow: "0px 0px 3.81px 0px rgba(0, 0, 0, 0.25)",
                          background:
                            "linear-gradient(180deg, #FFFFFF 0%, #FDF3FD 100%)",
                        }}
                      >
                        {/* Header Row */}
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            container
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography
                              color="#313439"
                              fontFamily="Inter"
                              fontSize="16px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              sx={{ fontWeight: 600 }}
                            >
                              {data?.class_id?.name} ({data?.type_of_session})
                            </Typography>
                          </Grid>

                          {/* Details */}
                          <Grid item xs={12} mt={1}>
                            <Grid container spacing={2}>
                              {/* Instructor */}
                              <Grid item xs={12} sm={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box width={24}>
                                    <img
                                      src="/newdashboard/DashboardClassAndDemo/Group 1171282736.png"
                                      alt="Instructor"
                                    />
                                  </Box>
                                  <Typography
                                    color="#161719"
                                    fontFamily="Inter"
                                    fontSize="13px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    {data?.class_id?.trainer_id?.first_name}{" "}
                                    {data?.class_id?.trainer_id?.last_name}
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* Mode */}
                              <Grid item xs={12} sm={12}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  // justifyContent="flex-end"
                                  gap={1}
                                >
                                  <Box width={24}>
                                    <img
                                      src="/newdashboard/DashboardClassAndDemo/Group 1171282735 (3).png"
                                      alt="Mode"
                                    />
                                  </Box>
                                  <Typography
                                    color="#161719"
                                    fontFamily="Inter"
                                    fontSize="13px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    {data?.class_id?.class_delivery_mode_id
                                      ? data?.class_id?.class_delivery_mode_id?.name
                                          .charAt(0)
                                          .toUpperCase() +
                                        data?.class_id?.class_delivery_mode_id?.name?.slice(
                                          1
                                        )
                                      : ""}
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* Date & Time */}
                              <Grid item xs={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box width={24}>
                                    <img
                                      src="/newdashboard/DashboardClassAndDemo/Group 1171282735 (4).png"
                                      alt="Date & Time"
                                    />
                                  </Box>
                                  <Typography
                                    color="#161719"
                                    fontFamily="Inter"
                                    fontSize="13px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    {data?.class_id?.start_time} -{" "}
                                    {data?.class_id?.end_time}
                                  </Typography>
                                </Box>
                              </Grid>

 {data?.class_id?.mode_of_delivery ===
                                "offline" && ( 
                                <Grid item xs={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box width={24} flexShrink={0}>
                                    <img
                                      src="/newdashboard/DashboardClassAndDemo/Group 1171285184.png"
                                      alt="Date & Time"
                                    />
                                  </Box>
                                  <Typography
                                    color="#161719"
                                    fontFamily="Inter"
                                    fontSize="13px"
                                    lineHeight="1.4"
                                    letterSpacing="0px"
                                    sx={{ fontWeight: 500 }}
                                   
                                  >
                                    {data?.class_id?.branch_id?.address} 
                                    
                                  </Typography>
                                </Box>
                              </Grid>
                                )}

                              {/* Join Demo */}
                              {data?.class_id?.mode_of_delivery ===
                                "online" &&  isToday(selectedDate) && (
                                <Grid item xs={12}>
                                  <BlueSmallButton
                                    buttonTitle={
                                      data?.type_of_session === "demo"
                                        ? "Join Demo"
                                        : "Join Class"
                                    }
                                    width="100%"
                                    onClick={(e) => {
                                        e.preventDefault(); // prevent any default navigation
                                      navigateToZoomLink(data?.class_id?.zoom_link);
                                    }}
                                  />
                                </Grid>
                              )}

                                 {data?.class_id?.mode_of_delivery ===
                                "online" &&  !isToday(selectedDate) && (
                                <Grid item xs={12}>
                                  <DisableBlueSmallButton
                                    buttonTitle={
                                      data?.type_of_session === "demo"
                                        ? "Join Demo"
                                        : "Join Class"
                                    }
                                    width="100%"
                                    fontSize="12px"
                                  />
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
            {/* Custom pagination below the images */}
            <Box sx={{ width: "100%", }}>
              <Box
                ref={paginationRef}
                className="custom-pagination-demo"
                sx={{
                  position: "absolute",
                  bottom: "-15px !important",
                  left: "50% !important",
                  transform: "translateX(-50%)",
                  zIndex: 10, // optional, to make sure it's above slides
                }}
              />
            </Box>
          </Box>
        ) : (
          <Grid item xs={12} mt={2}>
            {" "}
            <NoSessionsAvailable
              topImage={<img src="/newdashboard/_Clip Group_.png" />}
              //  text="No Test Type Purchased Yet"
              subText="No Session Available for Selected Date."
              imageSize={150}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}
